// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"59":"7a743e64","97":"2ad5b8b4","133":"76aaccf8","145":"7a743e64","197":"a62ea180","904":"6777b594"}[chunkId] + ".chunk.css";
};